import { deriveVaultPassphraseKey } from './vault';
import { encodeBase64, hkdfSha256 } from './primitives';

export const GUEST_LOGIN_VERIFY_HKDF_INFO = 'shareweb:guest-login-verify:v1';

/**
 * Derives the guest login verifier from PK. Never send PK or the passphrase to the server.
 * Server stores only a salted hash of this 32-byte verifier.
 */
export async function deriveGuestLoginVerifier(passphraseKey: Uint8Array): Promise<Uint8Array> {
  return hkdfSha256(passphraseKey, new Uint8Array(0), GUEST_LOGIN_VERIFY_HKDF_INFO, 32);
}

export async function deriveGuestLoginVerifierFromPassphrase(
  passphrase: string,
  vaultSalt: Uint8Array,
): Promise<{ passphraseKey: Uint8Array; loginVerifier: Uint8Array }> {
  const passphraseKey = await deriveVaultPassphraseKey(passphrase, vaultSalt);
  const loginVerifier = await deriveGuestLoginVerifier(passphraseKey);
  return { passphraseKey, loginVerifier };
}

export function encodeLoginVerifierBase64(loginVerifier: Uint8Array): string {
  return encodeBase64(loginVerifier);
}
